import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PiStarFourFill } from "react-icons/pi";
import { LuList } from "react-icons/lu";
import { FaBookmark } from "react-icons/fa";

const Jobs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="bg-[#F3F2EF] mt-16 ">
      <div className=" container mx-auto flex flex-col lg:flex-row gap-4 py-4 px-4 sm:px-6 lg:px-8">
        <div className="w-full lg:w-1/4">
          <div className="bg-white  rounded-lg shadow ">
            <div className="relative">
              <img
                src="https://placehold.co/600x200"
                alt="Creative design background"
                className="w-full h-28 object-cover rounded-t-lg "
              />
              <div className="absolute bottom-0 left-4 transform translate-y-1/2">
                <img
                  src="https://placehold.co/100x100"
                  alt="Profile picture of Erikson George"
                  className="size-24 rounded-full border-4 border-white"
                />
              </div>
            </div>
            <div className="pt-14 pb-6 px-6 text-start bg-white">
              <h1 className="text-2xl font-bold">Mike Wilshon</h1>
              <p className="text-gray-600">Web Designer At Logicspice</p>
              <p className="text-gray-500">Jaipur, Rajasthan</p>
              <div className="flex gap-1 items-center mt-6 ">
                <img
                  src="https://placehold.co/50x50"
                  alt="LogicSpice logo"
                  className=""
                />
                <p className="text-gray-600 text-start">
                  LogicSpice Consultancy Private Ltd.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-4 space-y-2 bg-white p-4 rounded-lg">
            <button className="w-full flex items-center p-2 gap-1.5 text-left text-gray-700 hover:bg-gray-200 rounded">
              {/* <i className="fas fa-search mr-2"></i>  */}
              <PiStarFourFill className="text-[18px] text-[#C37D16]" />
              Find Jobs With AI
            </button>
            <button className="w-full flex items-center p-2 gap-1.5 text-left text-gray-700 hover:bg-gray-200 rounded">
              {/* <i className="fas fa-sliders-h mr-2"></i>  */}
              <LuList className="text-[18px]" />
              Preferences
            </button>
            <button className="w-full flex items-center p-2 gap-1.5 text-left text-gray-700 hover:bg-gray-200 rounded">
              {/* <i className="fas fa-briefcase mr-2"></i>  */}
              <FaBookmark className="text-[18px]"/>
              My Jobs
            </button>
            <button className="w-full flex items-center p-2 text-left text-gray-700 hover:bg-gray-200 rounded">
              <i className="fas fa-chart-line mr-2"></i> My Career Insights
            </button>
          </div>
        </div>
        <div className="w-full lg:w-2/4 space-y-4">
          <div className="bg-white flex justify-between p-4 rounded-lg shadow ">
            <div>
              <h2 className="text-lg font-bold pr-0 sm:pr-40">
                Get Notified About Jobs You're Interested In
              </h2>
              <p className="text-sm text-gray-600">
                Create An Alert For A Job Title, A Company, Or Key Words.
              </p>
              <button
                onClick={openModal}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-full"
              >
                Create Alert
              </button>
              {isModalOpen && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10">
                  <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500">
                    <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px]">
                      <h2 className="text-xl font-semibold">
                        Create job alert
                      </h2>
                      <button
                        onClick={closeModal}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                    <form>
                      <div className="py-4 px-8 ">
                        <p className="text-red-500 text-sm">
                          * Indicates required
                        </p>

                        <h3 className="text-2xl font-bold mt-4 mb-4">
                          What kind of job are you looking for?
                        </h3>
                        <div className="mb-4">
                          <label className="block text-sm font-medium mb-1">
                            Job title <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Job title"
                            className="w-full border border-gray-300 rounded-md p-2"
                          />
                        </div>
                        <div className="mb-4">
                          <label className="block text-sm font-medium mb-1">
                            Job location <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Location"
                            className="w-full border border-gray-300 rounded-md p-2"
                          />
                        </div>
                        <p className="text-sm text-gray-600 mb-4">
                          We’ll send you relevant jobs that allow you to work
                          from this location.
                        </p>
                        <div>
                          <label className="block text-sm font-medium mb-2">
                            Workplace
                          </label>
                          <div className="flex space-x-1 sm:space-x-2 mb-6">
                            <button className="bg-blue-500 text-white text-sm sm:text-base px-2 py-2 rounded-full flex items-center space-x-1">
                              <span>On-site</span>
                              <i className="fas fa-check"></i>
                            </button>
                            <button className="bg-blue-500 text-white text-sm sm:text-base px-4 py-2 rounded-full flex items-center space-x-1">
                              <span>Hybrid</span>
                              <i className="fas fa-check"></i>
                            </button>
                            <button className="bg-blue-500 text-white text-sm sm:text-base px-4 py-2 rounded-full flex items-center space-x-1">
                              <span>Remote</span>
                              <i className="fas fa-check"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                        <button
                          type="submit"
                          className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-col justify-self-end ">
              <img src="/Images/jobs/Group.png" alt="" className="" />
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-lg font-bold">Job Picks For You</h2>
            <p className="text-sm text-gray-600">
              Based On Your Profile, Preferences, And Activity Like Applies,
              Searches, And Saves
            </p>
            <div className="mt-4 space-y-4">
              {[1, 2, 3].map((job, index) => (
                <Link to="/user/jobcollections">
                  <div
                    key={index}
                    className="flex justify-between p-4 border rounded-lg"
                  >
                    <div className="flex items-start  space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Company logo"
                        className="w-12 h-12 "
                      />
                      <div>
                        <h3 className="text-lg font-bold">UI Developer</h3>
                        <p className="text-sm text-gray-600">First Filing</p>
                        <p className="text-sm text-gray-600">
                          Jaipur, Rajasthan, India (On-Site)
                        </p>
                        <p className="text-sm text-gray-600">
                          ₹150K/Yr - ₹450K/Yr
                        </p>
                        <p className="text-sm text-blue-500">
                          Viewed{" "}
                          <span className="underline">
                            Be An Early Applicant
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-col justify-self-end ">
                      <button className="text-gray-500  hover:text-gray-700">
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <hr className="my-4" />
                </Link>
              ))}

              <div className="flex justify-center mt-4">
                <button className="text-gray-600 flex items-center hover:text-blue-500 group">
                  Show All
                  <i className="fas fa-arrow-right ml-2 transform transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg">
            <div className=" flex justify-between items-center mb-4">
              <div>
                <h2 className="text-xl font-bold">
                  Explore With Job Collections
                </h2>
                <p className="text-gray-500">
                  Broaden Your Job Search With Curated Collections
                </p>
              </div>
              <div className="flex space-x-2">
                <button className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300">
                  <i className="fas fa-chevron-left"></i>
                </button>
                <button className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300">
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
              <div className="flex flex-col items-center py-4 border rounded-lg">
                <img
                  src="https://placehold.co/64x64"
                  alt="Icon representing Social Impact"
                  className="mb-2"
                />
                <p className="font-semibold text-center">Social Impact</p>
              </div>
              <div className="flex flex-col items-center py-4 border rounded-lg">
                <img
                  src="https://placehold.co/64x64"
                  alt="Icon representing Sustainability"
                  className="mb-2"
                />
                <p className="font-semibold text-center">Sustainability</p>
              </div>
              <div className="flex flex-col items-center py-4 border rounded-lg">
                <img
                  src="https://placehold.co/64x64"
                  alt="Icon representing DEI"
                  className="mb-2"
                />
                <p className="font-semibold text-center">DEI</p>
              </div>
              <div className="flex flex-col items-center py-4 border rounded-lg">
                <img
                  src="https://placehold.co/64x64"
                  alt="Icon representing Career Growth"
                  className="mb-2"
                />
                <p className="font-semibold text-center">Career Growth</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Suggested Job Searches</h2>
              <button className="text-gray-500 hover:text-gray-700">
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="flex flex-wrap gap-2">
              <button className="flex items-center border border-blue-500 text-blue-500 rounded-full px-3 py-1">
                <i className="fas fa-search mr-2"></i> Remote
              </button>
              <button className="flex items-center border border-blue-500 text-blue-500 rounded-full px-3 py-1">
                <i className="fas fa-search mr-2"></i> Web Designer
              </button>
              <button className="flex items-center border border-blue-500 text-blue-500 rounded-full px-3 py-1">
                <i className="fas fa-search mr-2"></i> Graphic Web Designer
              </button>
              <button className="flex items-center border border-blue-500 text-blue-500 rounded-full px-3 py-1">
                <i className="fas fa-search mr-2"></i> Lead Web Designer
              </button>
              <button className="flex items-center border border-blue-500 text-blue-500 rounded-full px-3 py-1">
                <i className="fas fa-search mr-2"></i> Senior Web Designer
              </button>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/4 space-y-4">
          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-lg font-bold">Job Seeker Guidance</h2>
            <ul className="mt-4 space-y-2 text-sm text-gray-600">
              <li className="flex items-start space-x-2">
                <i className="fas fa-arrow-right mt-1"></i>
                <span>
                  We’ll keep your responses confidential and secure. They won’t
                  be shared with recruiters and employers.
                </span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="fas fa-arrow-right mt-1"></i>
                <span>
                  We’ll keep your responses confidential and secure. They won’t
                  be shared with recruiters and employers.
                </span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="fas fa-arrow-right mt-1"></i>
                <span>
                  We’ll keep your responses confidential and secure. They won’t
                  be shared with recruiters and employers.
                </span>
              </li>
            </ul>
            <button className="mt-4 text-blue-500">
              Show More <i className="fas fa-chevron-down"></i>
            </button>
          </div>
          <div className=" rounded-lg shadow">
            <img
              src="https://placehold.co/300x200"
              alt="Person working on a laptop"
              className="w-full rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Jobs;
